import { action, observable } from 'mobx';

class AnchorStore {
  @observable isAnchorLive = undefined;

  @action setIsAnchorLive = value => {
    this.isAnchorLive = value;
  }
}

export default new AnchorStore();